import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Consumer } from '../HighchartsContext';
import getDisplayName from '../../utils/getDisplayName'; // This is a HOC function.
// It takes a component...

export default function provideHighcharts(Component) {
  // ...and returns another component...
  var HighchartsWrappedComponent = function HighchartsWrappedComponent(props) {
    // ... and renders the wrapped component with the context Highcharts global
    // Notice that we pass through any additional props as well
    return React.createElement(Consumer, null, function (Highcharts) {
      return React.createElement(Component, _extends({}, props, {
        getHighcharts: function getHighcharts() {
          return Highcharts;
        }
      }));
    });
  };

  HighchartsWrappedComponent.displayName = "Highcharts.Provider(".concat(getDisplayName(Component), ")");
  return HighchartsWrappedComponent;
}